export default __webpack_public_path__ + "static/media/TimeElapse1.718d83c3.jpg";